<template>
    <div>
        <div>
            <v-card style="width: 100%; border-radius: 0px;" elevation="0" class="hidden-md-and-up">
                <v-row class="mt-2" style="max-height: fit-content">
                    <!-- Avatar alineado arriba -->
                    <v-col cols="auto" class="ml-4" style="max-width: 8%;">
                        <v-avatar color="white" size="25">
                            <img :src="profileImage" alt="Avatar"
                                style="max-width: 100%; max-height: 100%; object-fit: contain;">
                        </v-avatar>
                    </v-col>
                    <v-col>
                        <p style="font-weight: 600;" class="mb-0">{{ chatbotName }}</p>
                    </v-col>
                </v-row>
                <v-row>
                    <div class="ml-4 mr-4" :style="{
                        textAlign: 'justify',
                        color: 'black',
                        width: 'fit-content',
                    }">
                        <v-card-text class="pt-0">
                            <span v-html="welcomeMessage"></span>
                        </v-card-text>
                    </div>
                </v-row>

            </v-card>
        </div>

        <!--Message Container PC-->
        <div ref="messageContainer" class="hidden-sm-and-down" style="padding-left: 300px; padding-right: 300px;">
            <div v-for="(item) in messagesArray" :key="item.id">
                <v-card style="height: fit-content; width: 100%; border-radius: 15px;" elevation="0" class="mt-5">
                    <v-row no-gutters align="start" :style="item.uid !== '001' ? 'justify-content: flex-end;' : ''">
                        <div :style="{ maxWidth: '100%' }" class="mt-5">
                            <v-row>
                                <!-- Avatar alineado arriba -->
                                <v-col v-show="item.uid === '001' ? true : false" cols="auto"
                                    class="d-flex align-start ml-10 mt-2">
                                    <v-avatar v-show="item.uid === '001' ? true : false" color="white" size="40">
                                        <img :src="profileImage" alt="Avatar"
                                            style="max-width: 100%; max-height: 100%; object-fit: contain;">
                                    </v-avatar>
                                </v-col>

                                <!-- Contenedor del mensaje -->
                                <v-col class="d-flex mr-15">
                                    <div class="d-flex flex-column" :style="{
                                        textAlign: 'justify',
                                        color: 'black',
                                        backgroundColor: item.uid === '001' ? '' : '#E9E9E9C5',
                                        borderRadius: '15px',
                                        width: 'fit-content',

                                    }">
                                        <!--User Question-->
                                        <v-card-text v-show="item.uid === '001' ? false : true">
                                            <span v-html="item.content"></span>
                                        </v-card-text>
                                        <!--AI Answer-->
                                        <v-card-text v-show="item.uid === '001' ? true : false">
                                            <div v-if="!item.content.includes('MESSAGE_LIMIT_REACHED')"
                                                class="llm-content" v-html="sanitizedMarkdown(item.content)"></div>

                                            <v-alert dense v-if="item.content.includes('MESSAGE_LIMIT_REACHED')"
                                                border="left" colored-border icon="mdi-alert-circle-outline"
                                                type="error" elevation="1">
                                                <span style="font-size: small;">Your message limit has been
                                                    reached.</span>
                                            </v-alert>
                                            <v-btn x-small icon color="gray"
                                                v-if="!item.content.includes('MESSAGE_LIMIT_REACHED')"
                                                @click="copyToClipboard(item.content)" :loading="loadingCopy"><v-icon
                                                    x-small>mdi-content-copy</v-icon></v-btn>
                                            <v-btn x-small icon color="gray"
                                                v-if="!item.content.includes('MESSAGE_LIMIT_REACHED')"><v-icon
                                                    x-small>mdi-thumb-up-outline</v-icon></v-btn>
                                            <v-btn x-small icon color="gray"
                                                v-if="!item.content.includes('MESSAGE_LIMIT_REACHED')"><v-icon
                                                    x-small>mdi-thumb-down-outline</v-icon></v-btn>
                                        </v-card-text>

                                        <!-- Botones de enlace -->
                                        <div class="ml-2 mt-1" v-if="formatText(item.content).links.length > 0">
                                            <v-btn :dark="dark" rounded small
                                                v-for="(link, index) in formatText(item.content).links" :key="index"
                                                :href="link.link" target="_blank" :color="backgroundColor"
                                                class="mt-2 mb-2 mr-2">
                                                {{ link.type }}
                                                <v-icon x-small right>{{ link.icon }}</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>

                    </v-row>
                </v-card>
            </div>

            <!--Message Container Streaming-->
            <div v-if="showStreaming == true">
                <v-card style="height: fit-content; width: 100%; border-radius: 15px;" elevation="0" class="mt-7">
                    <v-row no-gutters align="start">
                        <!-- Avatar alineado arriba -->
                        <v-col cols="auto" class="d-flex align-start ml-10 mr-5">
                            <v-avatar color="white" size="40">
                                <img :src="profileImage" alt="Avatar"
                                    style="max-width: 100%; max-height: 100%; object-fit: contain;">
                            </v-avatar>
                        </v-col>
                        <v-col class="d-flex mr-15">
                            <div class="d-flex flex-column" :style="{
                                color: 'black',
                                borderRadius: '15px',
                                width: 'fit-content',

                            }">
                                <v-card-text>
                                    <div v-if="showStreamingText == true" class="llm-content"
                                        v-html="sanitizedMarkdown(incomingTextAnswer)"></div>
                                    <div class="loader mt-2" v-if="showStreamingText == false"></div>
                                </v-card-text>

                                <div v-if="formatText(incomingTextAnswer).links.length > 0" class="ml-4 mt-1">
                                    <v-btn :dark="dark" rounded small
                                        v-for="(link, index) in formatText(incomingTextAnswer).links" :key="index"
                                        :href="link.link" target="_blank" :color="backgroundColor"
                                        class="mt-4 mb-2 mr-2">
                                        {{ link.type }}<v-icon x-small right>{{ link.icon }}</v-icon></v-btn>
                                </div>
                            </div>

                        </v-col>
                    </v-row>

                </v-card>
            </div>
        </div>

        <!--Message Container Mobile-->
        <div ref="messageContainer" class="hidden-md-and-up">
            <div v-for="(item) in messagesArray" :key="item.id">
                <v-card style="height: fit-content; width: 100%; border-radius: 15px;" elevation="0" class="mt-5">
                    <v-row no-gutters align="start" :style="item.uid !== '001' ? 'justify-content: flex-end;' : ''">
                        <div :style="{ maxWidth: '100%' }">
                            <v-row v-show="item.uid === '001' ? true : false" class="mt-2">
                                <!-- Avatar alineado arriba -->
                                <v-col  cols="auto" class="ml-4" style="max-width: 8%;">
                                    <v-avatar color="white" size="25">
                                        <img :src="profileImage" alt="Avatar"
                                            style="max-width: 100%; max-height: 100%; object-fit: contain;">
                                    </v-avatar>
                                </v-col>
                                <v-col>
                                    <p style="font-weight: 600;" class="mb-0">{{ chatbotName }}</p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <!-- Contenedor del mensaje -->
                                    <div class="ml-4 mr-4" :class="item.uid === '001' ? '' : 'mr-5'" :style="{
                                        textAlign: 'justify',
                                        color: 'black',
                                        backgroundColor: item.uid === '001' ? '' : '#E9E9E9C5',
                                        borderRadius: '15px',
                                        
                                    }">
                                        <!--User Question-->
                                        <v-card-text v-show="item.uid === '001' ? false : true" class="ma-0">
                                            <span v-html="item.content"></span>
                                        </v-card-text>
                                        <!--AI Answer-->
                                        <v-card-text v-show="item.uid === '001' ? true : false" class="pt-0">
                                            <div v-if="!item.content.includes('MESSAGE_LIMIT_REACHED')"
                                                class="llm-content" v-html="sanitizedMarkdown(item.content)"></div>

                                            <!-- Renderizado de imágenes -->
                                            <div class="ml-2 mt-3"
                                                v-if="getMediaItems(item.content, 'Image').length > 0">
                                                <v-row>
                                                    <v-col
                                                        v-for="(image, index) in getMediaItems(item.content, 'Image')"
                                                        :key="`img-${index}`" class="d-flex justify-center">
                                                        <v-card elevation="0" class="ma-2"
                                                            style="max-width: 300px; border-radius: 12px; overflow: hidden;">
                                                            <v-img :src="image.link" :alt="`Imagen ${index + 1}`"
                                                                max-height="250" contain class="clickable-image"
                                                                @click="openImageDialog(image.link)"
                                                                style="cursor: pointer;">
                                                                <template v-slot:placeholder>
                                                                    <v-row class="fill-height ma-0" align="center"
                                                                        justify="center">
                                                                        <v-progress-circular indeterminate
                                                                            color="grey lighten-5"></v-progress-circular>
                                                                    </v-row>
                                                                </template>
                                                            </v-img>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                            </div>

                                            <!-- Renderizado de videos MP4 -->
                                            <div class="" v-if="getMediaItems(item.content, 'Video').length > 0">
                                                <v-row>
                                                    <v-col
                                                        v-for="(video, index) in getMediaItems(item.content, 'Video')"
                                                        :key="`video-${index}`" class="d-flex justify-center">
                                                        <v-card elevation="0" class="ma-2"
                                                            style="max-width: 400px; border-radius: 12px; overflow: hidden;">
                                                            <video :src="video.link" controls loop autoplay
                                                                preload="metadata"
                                                                style="width: 100%; height: auto; max-height: 300px;">
                                                                Tu navegador no soporta el elemento video.
                                                            </video>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                            </div>

                                            <v-alert dense v-if="item.content.includes('MESSAGE_LIMIT_REACHED')"
                                                border="left" colored-border icon="mdi-alert-circle-outline"
                                                type="error" elevation="1">
                                                <span style="font-size: small;">Your message limit has been
                                                    reached.</span>
                                            </v-alert>
                                            
                                        <!-- Botones de enlace -->
                                        <div class="ml-2 mt-1" v-if="formatText(item.content).links.length > 0">
                                            <v-btn :dark="dark" rounded small
                                                v-for="(link, index) in formatText(item.content).links" :key="index"
                                                :href="link.link" target="_blank" :color="backgroundColor"
                                                class="mt-2 mb-2 mr-2">
                                                {{ link.type }}
                                                <v-icon x-small right>{{ link.icon }}</v-icon>
                                            </v-btn>
                                        </div>
                                            <v-btn small icon color="gray"
                                                v-if="!item.content.includes('MESSAGE_LIMIT_REACHED')"
                                                @click="copyToClipboard(item.content)" :loading="loadingCopy"><v-icon
                                                    small>mdi-content-copy</v-icon></v-btn>
                                            <v-btn small icon color="gray"
                                                v-if="!item.content.includes('MESSAGE_LIMIT_REACHED')"><v-icon
                                                    small>mdi-thumb-up-outline</v-icon></v-btn>
                                            <v-btn small icon color="gray"
                                                v-if="!item.content.includes('MESSAGE_LIMIT_REACHED')"><v-icon
                                                    small>mdi-thumb-down-outline</v-icon></v-btn>
                                        </v-card-text>

                                    </div>
                            </v-row>
                        </div>

                    </v-row>
                </v-card>
            </div>

            <!--Message Container Streaming-->
            <div v-if="showStreaming == true">
                <v-card style="height: fit-content; width: 100%; border-radius: 15px;" elevation="0" class="mt-7">
                    <v-row no-gutters align="start">
                        <!-- Avatar alineado arriba -->
                        <v-col cols="auto" class="ml-4" style="max-width: 8%;">
                            <v-avatar color="white" size="25">
                                <img :src="profileImage" alt="Avatar"
                                    style="max-width: 100%; max-height: 100%; object-fit: contain;">
                            </v-avatar>
                        </v-col>
                        <v-col>
                            <p style="font-weight: 600;" class="mb-0 ml-2">{{ chatbotName }}</p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <div class="ml-3" :style="{
                            color: 'black',
                            borderRadius: '15px',
                            width: 'fit-content',

                        }">
                            <v-card-text class="pt-0">
                                <div v-if="showStreamingText == true" class="llm-content ml-2 mr-4"
                                    style="text-align: justify;" v-html="sanitizedMarkdown(incomingTextAnswer)"></div>
                                <div class="loader mt-2 ml-2" v-if="showStreamingText == false"></div>
                            </v-card-text>

                            <div v-if="formatText(incomingTextAnswer).links.length > 0" class="ml-4 mt-1">
                                <v-btn :dark="dark" rounded small
                                    v-for="(link, index) in formatText(incomingTextAnswer).links" :key="index"
                                    :href="link.link" target="_blank" :color="backgroundColor" class="mt-4 mb-2 mr-2">
                                    {{ link.type }}<v-icon x-small right>{{ link.icon }}</v-icon></v-btn>
                            </div>
                        </div>

                    </v-row>

                    <br>

                </v-card>
            </div>
            <br>
        </div>

        <v-footer app inset style="background-color: transparent;">
            <div style="background-color: white; border-radius: 20px; border: 1px solid #C0C0C0; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); width: 100%; max-width: 600px;"
                class="mx-auto">

                <v-progress-linear v-if="loadingConnection" indeterminate
                    :color="backgroundColor == '#FFFFFF' ? 'black' : backgroundColor" class="mx-auto"
                    style="width: 340px;"></v-progress-linear>
                <div @submit.prevent="sendMessageWS()" class="mx-auto">
                    <v-textarea label="Ask anything" solo flat dense color="white" style=" box-shadow: none !important;"
                        required hide-details="false" class="mx-auto auto-resize ml-2 mr-2 mt-2"
                        @keydown.enter.prevent="sendMessageWS()" v-model="message" :disabled="loadingFlag"
                        loader-height="5" auto-grow rows="1"> </v-textarea>
                    <v-row>
                        <v-col style="text-align: end;">
                            <v-btn class="mr-2 mb-2 white--text" icon :style="{ backgroundColor: backgroundColor }"
                                :loading="loadingFlag" @click="sendMessageWS()"><v-icon color="white"
                                    small>mdi-arrow-up</v-icon></v-btn>
                        </v-col>
                    </v-row>
                </div>

            </div>
            <div style="width: 100%; text-align: center; ">
                <a href="https://chatpro.pro" target="_blank" style="text-decoration: none; color: black">
                    <span style="font-size: 10px; color: black;">Powered by <b><img
                                src="https://d7nzzuxaahac2.cloudfront.net/web/chatpro_black_logo_small.webp"
                                alt="Logo de ChatPro AI"
                                style="height: 14px; margin-right: 4px;margin-left: 4px; vertical-align: middle;" />ChatPro
                            AI</b></span>
                </a>
            </div>
        </v-footer>

        <!-- get user personal data -->
        <v-dialog class="mt-4" v-model="contactFormFlag" max-width="500px" persistent
            v-if="contactFormFlag && !adminContactFlag" style="">
            <v-card color="white" style="border-radius: 10px; max-width: 550px; overflow-x: hidden !important;"
                class="mx-auto">
                <v-row class="mb-1">
                    <v-col>
                        <p style="color:black; text-align: left; font-size: 1.1rem; font-weight: 500;"
                            class="ml-5 ma-3">Share your contact info!</p>
                    </v-col>
                    <v-col style="text-align: right; max-width: 20%;">
                        <v-btn small class="ma-3" color="black" icon @click="closeContactForm()">
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-form style="width: 100%;" @submit.prevent="addUserContactData()">
                    <p style="color:black; text-align: left; font-size: 0.9rem; font-weight: 500;" class="ml-5">Name</p>
                    <v-text-field dense :color="backgroundColor" required outlined @click:append="addUserContactData()"
                        v-model="userContactName" class="ml-5 mr-5 custom-text-field"> </v-text-field>

                    <p style="color:black; text-align: left; font-size: 0.9rem; font-weight: 500;" class="ml-5">Email
                    </p>
                    <v-text-field type="email" dense :color="backgroundColor" required outlined :rules="emailRules"
                        @click:append="addUserContactData()" @input="validateEmail" v-model="userContact"
                        placeholder="user@example.com" class="ml-5 mr-5 custom-text-field"></v-text-field>

                </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn rounded :color="backgroundColor" :dark="dark" :disabled="!isValidEmail || loadingContactData"
                        :loading="loadingContactData" class="white--text mr-1 mb-3" small
                        @click="addUserContactData()">Submit<v-icon right x-small>mdi-send</v-icon></v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
    </div>
</template>


<script>
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import axiosChat from "@/logic/B2C/register_chats_chatpro/axiosChat.js";


Vue.use(VueToast);


import { marked } from 'marked';
import DOMPurify from 'dompurify';

export default {
    name: 'chatBotMessages',
    props: {
        chatbotName: { type: String, required: true },
        backgroundColor: { type: String, required: true },
        dark: { type: Boolean, required: true },
        idConversation: { type: String, required: true },
        messages: { type: Array, required: true },
        profileImage: { type: String, required: true },
        adminContactFlag: { type: Boolean, required: true },
        id_chatbot: { type: String, required: true },
        welcomeMessage: { type: String, required: true }
    },

    data() {
        return {
            //variables for get contact data
            userContactName: "",
            userContact: "",

            emailRules: [
                (value) => !value || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'E-mail must be valid'
            ],
            isValidEmail: false,
            loadingContactData: false,
            contactFormFlag: false,
            showStreaming: false,
            showStreamingText: false,
            incomingTextAnswer: "",
            message: '',
            loadingFlag: false,
            loadingCopy: false,
            messagesArray: [...this.messages],
            loadingConnection: false
        }

    },

    updated() {
        this.$refs.messageContainer.scrollTop = this.$refs.messageContainer.scrollHeight;
        window.scrollTo(0, document.body.scrollHeight);

    },

    watch: {
        messages(newVal) {
            this.messagesArray = [...newVal]; // actualiza si el prop cambia
        }
    },

    methods: {

        validateEmail() {
            const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
            this.isValidEmail = emailRegex.test(this.userContact)
        },

        async addUserContactData() {
            this.loadingContactData = true //activa loader del boton
            // console.log(this.userContact, this.idConversation)

            const responseUpdateContactConversation = await axiosChat.update_contact_data(this.userContactName, this.userContact, this.idSession)
            if (responseUpdateContactConversation.data.code == "success") {
                this.loadingContactData = false //Desactiva loader del boton
                this.contactFormFlag = false //oculta el form
                Vue.$toast.open({
                    message: '<p style="font-family: poppins;">User data updated!</p>',
                    type: 'success',
                    position: 'top',
                    duration: 3000
                });
            }
            else {
                this.loadingContactData = false //Desactiva loader del boton
                this.contactFormFlag = true //Muestra el form
                Vue.$toast.open({
                    message: '<p style="font-family: poppins;">Something failed please try again!</p>',
                    type: 'error',
                    position: 'top',
                    duration: 3000
                });
            }

        },

        copyToClipboard(text) {
            this.loadingCopy = true;

            const fallback = () => {
                const textarea = document.createElement('textarea');
                textarea.value = text;
                textarea.style.position = 'fixed';
                textarea.style.opacity = 0;
                document.body.appendChild(textarea);
                textarea.focus();
                textarea.select();
                try {
                    document.execCommand('copy');
                    Vue.$toast.open({
                        message: '<p style="font-family: poppins;">Text copied to clipboard.</p>',
                        type: 'success',
                        position: 'top',
                        duration: 1000,
                    });
                } catch (err) {
                    Vue.$toast.open({ message: 'Copy failed', type: 'error', position: 'top', });
                }
                document.body.removeChild(textarea);
            };

            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text)
                    .then(() => Vue.$toast.open({
                        message: '<p style="font-family: poppins;">Text copied to clipboard.</p>',
                        type: 'success',
                        position: 'top',
                        duration: 1000,
                    }))
                    .catch(fallback)
                    .finally(() => this.loadingCopy = false);
            } else {
                fallback();
                this.loadingCopy = false;
            }
        },

        sanitizedMarkdown(content) {
            if (!content) return '';

            try {
                // 1. Configuración limpia de Marked
                marked.setOptions({
                    gfm: true,        // Github Flavored Markdown (necesario)
                    breaks: true,     // Enter = Salto de linea (<br>)
                    headerIds: false, // Evita que agregue id="titulo" que ensucia el HTML
                    mangle: false     // Evita ofuscar emails
                });

                // 2. Parsear a HTML
                let rawHtml = marked.parse(content);

                // 3. Configuración ESTRICTA de DOMPurify
                const purifyConfig = {
                    // NOTA: He quitado 'hr' de esta lista. 
                    // Si el LLM manda '---', el <hr> resultante será eliminado.
                    ALLOWED_TAGS: [
                        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
                        'p', 'br', 'strong', 'em', 'u', 's',
                        'ul', 'ol', 'li', 'blockquote', 'code', 'pre',
                        'a', 'img', 'table', 'thead', 'tbody', 'tr', 'th', 'td'
                    ],
                    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'target'],
                    FORBID_TAGS: ['style', 'script', 'hr'], // Aseguramos que 'hr' muera
                };
                console.log(rawHtml)
                // 4. Sanitizar
                return DOMPurify.sanitize(rawHtml, purifyConfig);

            } catch (error) {
                console.error('Error procesando markdown:', error);
                return content;
            }
        },

        fastPrompt(prompt) {
            this.message = prompt
            this.sendMessageWS()

        },

        formatText(text) {
            // Regex mejorado para URLs que maneja mejor los caracteres de markdown
            const urlRegex = /(https?:\/\/[^\s)]+?)(?=[\s)\]}]|$)/gi;

            const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
            const phoneRegex = /(?:^|\s)(\+\d{1,2}\s?)?(\d{7,14})(?=$|[\s.,:;])/g;

            // Regex para imágenes (incluye más formatos comunes)
            const imageRegex = /(https?:\/\/[^\s)]+\.(?:jpg|jpeg|png|gif|webp|bmp|svg))(?=[\s)\]}]|$)/gi;

            // Nuevo regex para videos MP4
            const videoRegex = /(https?:\/\/[^\s)]+\.mp4)(?=[\s)\]}]|$)/gi;

            const urlMatches = text.match(urlRegex) || [];
            const emailMatches = text.match(emailRegex) || [];
            const phoneMatches = text.match(phoneRegex) || [];
            const imageMatches = text.match(imageRegex) || [];
            const videoMatches = text.match(videoRegex) || [];

            const links = [];

            // Procesar URLs (excluyendo imágenes y videos)
            if (urlMatches.length > 0) {
                const urls = urlMatches.map(match => match.trim());

                // Filtrar URLs que no son imágenes ni videos
                const filteredUrls = urls.filter(url => {
                    const lowercaseUrl = url.toLowerCase();
                    return !lowercaseUrl.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg|mp4)$/i);
                });

                const urlLinks = filteredUrls.map(url => ({
                    type: "Link",
                    link: url,
                    icon: "mdi-open-in-new"
                }));

                links.push(...urlLinks);
            }

            // Procesar emails
            if (emailMatches.length > 0) {
                const emails = emailMatches.map(match => match.trim());
                const emailLinks = emails.map(email => ({
                    type: "Email",
                    link: `mailto:${email}`,
                    icon: "mdi-email"
                }));
                links.push(...emailLinks);
            }

            // Procesar teléfonos
            if (phoneMatches.length > 0) {
                const phones = phoneMatches.map(match => match.trim());
                const phoneLinks = phones.map(phone => ({
                    type: "Tel",
                    link: `tel:${phone}`,
                    icon: "mdi-phone"
                }));
                links.push(...phoneLinks);
            }

            // Procesar imágenes
            if (imageMatches.length > 0) {
                const images = imageMatches.map(match => match.trim());
                const imageLinks = images.map(image => ({
                    type: "Image",
                    link: image,
                    icon: "mdi-image"
                }));
                links.push(...imageLinks);
            }

            // Procesar videos MP4
            if (videoMatches.length > 0) {
                const videos = videoMatches.map(match => match.trim());
                const videoLinks = videos.map(video => ({
                    type: "Video",
                    link: video,
                    icon: "mdi-play-circle"
                }));
                links.push(...videoLinks);
            }

            // Remover duplicados basándose en el link
            const uniqueLinks = links.filter((link, index, self) =>
                index === self.findIndex(l => l.link === link.link)
            );

            // Filtrar links que no son imágenes para el retorno
            const linksNoImages = uniqueLinks.filter(link => link.type !== 'Image');

            if (uniqueLinks.length > 0) {
                let textWithLinks = text;

                // Reemplazar en orden: primero videos, luego imágenes, luego links, emails y teléfonos
                uniqueLinks.forEach(curr => {
                    if (curr.type === "Email") {
                        const emailLinkInText = curr.link.replace('mailto:', '');
                        const emailRegexReplace = new RegExp(emailLinkInText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
                        textWithLinks = textWithLinks.replace(emailRegexReplace,
                            `<a href="${curr.link}" target="_blank">${emailLinkInText}</a>`);
                    }
                    else if (curr.type === "Image") {
                        const imageRegexReplace = new RegExp(curr.link.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
                        textWithLinks = textWithLinks.replace(imageRegexReplace,
                            `<img src="${curr.link}" alt="image" style="max-width: 250px; height: auto; display: block; margin: 0 auto; margin-top: 20px">`);
                    }
                    else if (curr.type === "Video") {
                        const videoRegexReplace = new RegExp(curr.link.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
                        textWithLinks = textWithLinks.replace(videoRegexReplace,
                            `<video controls style="max-width: 350px; height: auto; display: block; margin: 0 auto; margin-top: 20px">
                        <source src="${curr.link}" type="video/mp4">
                        Tu navegador no soporta el elemento video.
                        <a href="${curr.link}" target="_blank">Ver video</a>
                    </video>`);
                    }
                    else if (curr.type === "Link") {
                        const linkRegexReplace = new RegExp(curr.link.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
                        textWithLinks = textWithLinks.replace(linkRegexReplace,
                            `<a href="${curr.link}" target="_blank">${curr.link}</a>`);
                    }
                    else if (curr.type === "Tel") {
                        const phoneNumber = curr.link.replace('tel:', '');
                        const phoneRegexReplace = new RegExp(phoneNumber.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
                        textWithLinks = textWithLinks.replace(phoneRegexReplace,
                            `<a href="${curr.link}">${phoneNumber}</a>`);
                    }
                });

                return { text: textWithLinks, links: linksNoImages };
            } else {
                return { text: text, links: [] };
            }
        },

        getMediaItems(content, type) {
            const formattedContent = this.formatText(content);
            return formattedContent.links.filter(link => link.type === type);
        },

        connectWebSocket() {
            // Si ya hay una conexión activa, no crear otra
            if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.updateLastActivity();
                return Promise.resolve();
            }

            // Si ya se está conectando, esperar
            if (this.loadingConnection) {
                return new Promise((resolve) => {
                    const checkConnection = () => {
                        if (!this.loadingConnection) {
                            resolve();
                        } else {
                            setTimeout(checkConnection, 100);
                        }
                    };
                    checkConnection();
                });
            }

            return new Promise((resolve, reject) => {
                this.loadingConnection = true;
                this.ws = new WebSocket(`wss://9b15vs7go0.execute-api.us-east-1.amazonaws.com/pdn/?id_chatbot=${this.id_chatbot}&id_session=${this.idConversation}`);

                console.log(this.ws.url)

                this.ws.onopen = () => {
                    console.log("Conectado al WebSocket");
                    this.loadingConnection = false;
                    this.updateLastActivity();
                    this.scheduleDisconnection();
                    resolve();
                };

                this.ws.onmessage = (event) => {
                    try {
                        this.updateLastActivity(); // Actualizar actividad al recibir mensajes
                        this.showStreamingText = true;
                        const data = JSON.parse(event.data);
                        this.incomingTextAnswer += data.content;
                        console.log(data.content);

                        if (data.finish_reason === "stop") {
                            console.log(data);
                            this.idSession = data.id_session
                            console.log(this.idSession)
                            const messageBot = {
                                content: this.incomingTextAnswer,
                                display_name: "Assistant",
                                role: "assistant",
                                uid: "001",
                                sources: data.sources
                            };

                            this.messagesArray.push(messageBot);

                            this.incomingTextAnswer = "";
                            this.loadingFlag = false;
                            this.showStreaming = false;
                            this.showStreamingText = false;

                            if (this.userContact == "") {
                                this.contactFormFlag = true
                            }

                            // Reagendar desconexión después de completar respuesta
                            this.scheduleDisconnection();
                        }

                    } catch (e) {
                        console.error("Error al parsear JSON:", e);
                        this.showStreaming = false;
                    }
                };

                this.ws.onerror = (error) => {
                    console.error("Error en WebSocket:", error);
                    this.loadingConnection = false;
                    reject(error);
                };

                this.ws.onclose = () => {
                    console.warn("WebSocket cerrado");
                    this.loadingConnection = false;
                    this.clearConnectionTimeout();
                };
            });
        },

        disconnectWebSocket() {
            if (this.ws) {
                this.ws.close();
                this.ws = null;
            }
            this.clearConnectionTimeout();
        },

        updateLastActivity() {
            this.lastActivity = Date.now();
        },

        scheduleDisconnection() {
            // Limpiar timeout anterior
            this.clearConnectionTimeout();

            // Programar nueva desconexión
            this.connectionTimeout = setTimeout(() => {
                const timeSinceLastActivity = Date.now() - this.lastActivity;

                if (timeSinceLastActivity >= this.INACTIVITY_TIMEOUT) {
                    console.log("Desconectando WebSocket por inactividad");
                    this.disconnectWebSocket();
                } else {
                    // Si hubo actividad reciente, reagendar
                    const remainingTime = this.INACTIVITY_TIMEOUT - timeSinceLastActivity;
                    this.connectionTimeout = setTimeout(() => {
                        this.scheduleDisconnection();
                    }, remainingTime);
                }
            }, this.INACTIVITY_TIMEOUT);
        },

        clearConnectionTimeout() {
            if (this.connectionTimeout) {
                clearTimeout(this.connectionTimeout);
                this.connectionTimeout = null;
            }
        },

        async sendMessageWS() {
            if (this.message === '') {
                return;
            }

            try {
                // Asegurar conexión antes de enviar
                await this.connectWebSocket();

                console.log("Send Message: ", this.message);

                if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                    this.loadingFlag = true;
                    this.showStreaming = true;
                    this.showStreamingText = false;
                    this.updateLastActivity(); // Actualizar actividad al enviar mensaje

                    const payload = {
                        action: "chatMessage",
                        id_chatbot: this.id_chatbot,
                        question: this.message,
                        id_session: this.idConversation,
                    };

                    this.ws.send(JSON.stringify(payload));

                    const messageAux = {
                        content: this.message,
                        display_name: "User",
                        role: "user",
                        uid: "002"
                    };

                    this.message = "";
                    this.messagesArray.push(messageAux);
                    // this.$emit('messages', this.messagesArray, messageAux, false);

                } else {
                    throw new Error("WebSocket no está disponible");
                }
            } catch (error) {
                console.error("Error al enviar mensaje:", error);
                this.loadingFlag = false;
                this.showStreaming = false;

                // Opcional: mostrar mensaje de error al usuario
                // this.$emit('error', 'Error de conexión. Por favor, inténtalo de nuevo.');
            }
        },

        closeContactForm() {
            this.contactFormFlag = false
        }
    },

}
</script>

<style scoped>
.v-btn {
    text-transform: none;
}

.custom-text-field input {
    font-size: 13px;
}

@media screen and (max-width: 1904px) {
    .avatar-container {
        width: 100px;

        height: 100px;

    }

    .squared-avatar {
        border-radius: 6px !important;

        overflow: hidden !important;

        margin-top: 22px;
    }

}

@media screen and (max-width: 820px) {
    .avatar-container {
        width: 100px;

        height: 100px;

    }

    .squared-avatar {
        border-radius: 6px !important;

        overflow: hidden !important;

        margin-top: 22px;
    }
}

@media screen and (max-width: 700px) {
    .avatar-container {
        width: 70px;

        height: 70px;

    }

    .squared-avatar {
        border-radius: 6px !important;

        overflow: hidden !important;

        margin-top: 22px;
    }
}

@media screen and (max-width: 600px) {
    .avatar-container {
        width: 50px;

        height: 50px;

    }

    .squared-avatar {
        border-radius: 6px !important;

        overflow: hidden !important;

        margin-top: 22px;
    }
}

@media screen and (max-width: 360px) {
    .avatar-container {
        width: 50px;

        height: 50px;

    }

    .squared-avatar {
        border-radius: 6px !important;

        overflow: hidden !important;

        margin-top: 22px;
    }
}


.loader {
    width: 35px;
    aspect-ratio: 4;
    --_g: no-repeat radial-gradient(circle closest-side, #6a6a6a 90%, #0000);
    background:
        var(--_g) 0% 50%,
        var(--_g) 50% 50%,
        var(--_g) 100% 50%;
    background-size: calc(100%/3) 100%;
    animation: l7 1s infinite linear;
}

@keyframes l7 {
    33% {
        background-size: calc(100%/3) 0%, calc(100%/3) 100%, calc(100%/3) 100%
    }

    50% {
        background-size: calc(100%/3) 100%, calc(100%/3) 0%, calc(100%/3) 100%
    }

    66% {
        background-size: calc(100%/3) 100%, calc(100%/3) 100%, calc(100%/3) 0%
    }
}

/* Estilos para el contenido del LLM */
.llm-content {
    word-break: break-word;     /* Rompe palabras/enlaces largos si es necesario */
    overflow-wrap: break-word;  /* Asegura que el texto no desborde el contenedor */
    color: #222222;
    /* Un gris oscuro, menos agresivo que el negro puro */
    line-height: 1.6;
    /* Mejor lectura */
}

/* Espaciado general entre párrafos */
.llm-content ::v-deep p {
    margin-bottom: 16px;
    /* Reemplaza tus <br> manuales */
}


.llm-content ::v-deep iframe {
  width: 100% !important;       /* Fuerza al iframe a ocupar el ancho del contenedor */
  max-width: 100%;              /* Evita que se salga si tiene un ancho fijo en el HTML */
  border-radius: 12px;          /* Opcional: bordes redondeados estilo chat moderno */
  border: none;                 /* Quita el borde feo por defecto */
  margin-bottom: 15px;
  
  /* IMPORTANTE: Altura */
  /* Si el iframe no trae altura, ponle una mínima para que no se vea una línea delgada */
  min-height: 600px; 
}

/* Títulos: Quitamos el "negro total" y ajustamos tamaños */
.llm-content ::v-deep h2,
.llm-content ::v-deep h3 {
    color: #222222;
    /* Gris oscuro suave de Vuetify */
    margin-top: 24px;
    margin-bottom: 16px;
    font-weight: 500;
    /* Menos grueso que el bold normal (700) */
    line-height: 1.3;
}


.llm-content ::v-deep h1 {
    color: #222222;
    /* Gris oscuro suave de Vuetify */
    /* margin-top: 24px; */
    margin-bottom: 16px;
    font-weight: 500;
    /* Menos grueso que el bold normal (700) */
    line-height: 1.3;
}

.llm-content ::v-deep p strong {
    font-weight: 550;
}

/* Ajuste de tamaños para que no sean gigantes */
.llm-content ::v-deep h1 {
    font-size: 1.3rem;
}

.llm-content ::v-deep h2 {
    font-size: 1.15rem;
}

.llm-content ::v-deep h3 {
    font-size: 1rem;
}

.llm-content ::v-deep h2 strong {
    font-weight: 550;
}

.llm-content ::v-deep h3 strong {
    font-weight: 550;
}


/* Listas */
.llm-content ::v-deep ul,
.llm-content ::v-deep ol {
    margin-bottom: 16px;
    padding-left: 24px;
}

.llm-content ::v-deep li {
    margin-bottom: 8px;
}

.llm-content ::v-deep li strong {
    /* Usamos 500, que es el valor válido más cercano a 550 y más suave que 600. */
    font-weight: 550 !important;
}

.llm-content ::v-deep td strong {
    /* Usamos 500, que es el valor válido más cercano a 550 y más suave que 600. */
    font-weight: 550 !important;
}

/* Bloques de código (opcional pero recomendado para LLMs) */
.llm-content ::v-deep pre {
    background-color: #f5f5f5;
    padding: 12px;
    border-radius: 4px;
    overflow-x: auto;
    margin-bottom: 16px;
}

.llm-content ::v-deep code {
    background-color: #f5f5f5;
    padding: 2px 4px;
    border-radius: 2px;
    box-shadow: none;
    /* Vuetify a veces pone sombra al code, esto la quita */
}

/* --- Estilos para Tablas Markdown --- */

/* Contenedor de la tabla */
.llm-content ::v-deep table {
    width: 100%;
    border-collapse: collapse;
    /* Importante para que los bordes se unan */
    margin-top: 16px;
    margin-bottom: 24px;
    background-color: transparent;
    border-radius: 4px;
    overflow: hidden;
    /* Para respetar el border-radius en las esquinas */
}

/* Celdas generales (Encabezado y Cuerpo) */
.llm-content ::v-deep th,
.llm-content ::v-deep td {
    padding: 5px 16px;
    /* Espaciado interno cómodo */
    text-align: left;
    border-bottom: 1px solid #e0e0e0;
    /* Borde sutil estilo Vuetify */
    font-size: 0.8rem;
}

/* Estilos específicos para el encabezado (Títulos) */
.llm-content ::v-deep th {
    background-color: #f5f5f5;
    /* Un gris muy suave para diferenciar el header */
    color: #222222
}

.llm-content ::v-deep th strong {
    font-weight: 550;
}

/* Opcional: Hover en las filas para mejor lectura */
.llm-content ::v-deep tr:hover td {
    background-color: #fafafa;
}

/* Responsividad: Contenedor para scroll horizontal en móviles */
/* Nota: Como v-html inyecta la tabla directo, para scroll en móvil 
   necesitarías un div envoltorio, pero este CSS asegura que no rompa el layout */
/* .llm-content ::v-deep table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
} */
/* En pantallas grandes, quitamos el bloque para que ocupe el ancho real */
@media (min-width: 600px) {
    .llm-content ::v-deep table {
        display: table;
        white-space: normal;
    }
}
</style>
